
import React, { Component } from 'react';
import '../App.css';
import Button from '@material-ui/core/Button';
import CssBaseline from '@material-ui/core/CssBaseline';
import TextField from '@material-ui/core/TextField';
import Typography from '@material-ui/core/Typography';
import { withStyles } from '@material-ui/core/styles';
import Container from '@material-ui/core/Container';
import Link from '@material-ui/core/Link';
import Grid from '@material-ui/core/Grid';
import CircularProgress from '@material-ui/core/CircularProgress';
import history from '../Config/history'
import firebase from '../Config/Firebase'


const styles = theme => ({
  '@global': {
    body: {
      backgroundColor: theme.palette.common.white,
    },
  },
  paper: {
    marginTop: theme.spacing(8),
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  progress: {
    margin: theme.spacing(2),
  },
  avatar: {
    margin: theme.spacing(1),
    backgroundColor: theme.palette.secondary.main,
  },
  form: {
    width: '100%', // Fix IE 11 issue.
    marginTop: theme.spacing(1),
  },
  submit: {
    margin: theme.spacing(3, 0, 2),
  },
});

class App extends Component {

  constructor() {
    super();
    this.state = {
      email: "",
      password: "",
      login: false,
      wrong: false,
      notadmin: false,
      loading: false,
      uid: "",
      forgot: false,
      wrongs: false,
      again: false
    }
  }

  checkuser = () => {

  }



  forgotPassword = () => {
    firebase.auth().sendPasswordResetEmail(this.state.email)
      .then(() => {
        alert('Please check your email...')
        this.setState({ forgot: false })
      }).catch((e) => {
        this.setState({ wrongs: true })
        this.setState({ loading: false })

        setTimeout(() => {
          this.setState({ wrongs: false })
        }, 3000)
      })
  }





  login = () => {
    this._isMounted = true
    this.setState({ loading: true })
    firebase.auth().signInWithEmailAndPassword(this.state.email, this.state.password).then((user) => {
      if (user) {
        firebase.database().ref(`admin/${firebase.auth().currentUser.uid}`).on("value", (snapshot) => {
          //console.log(firebase.auth().currentUser.uid,"dfdfdf")
          if (snapshot.val() != null) {
            //console.log(snapshot.val(),"val")
            localStorage.setItem('User', JSON.stringify(user));
            this.props.login();
            history.push('/homepage')

          }
          else {

            //console.log("not entered home")

            firebase.auth().signOut();
            if (this._isMounted) { this.setState({ notadmin: true }) }
            if (this._isMounted) {
              this.setState({ loading: false })
              setTimeout(() => {
                this.setState({ notadmin: false })
              }, 3000)
            }

          }
        })


      }


    }).catch((error) => {
      //console.log(error)
      this.setState({ wrong: true })
      this.setState({ loading: false })

      setTimeout(() => {
        this.setState({ wrong: false })
      }, 3000)
    })



  }






  render() {
    const { classes } = this.props;

    return (
      <div className="login">
        {this.state.loading ? (<CircularProgress style={{ margin: "20vh" }} className={classes.progress} />) :
          (<Container component="main" maxWidth="xs">
            <CssBaseline />
            <div className={classes.paper}>
              <img src={require("../assets/Summitlogo.jpg")} width={350} />
              {this.state.forgot ? (<Typography component="h1" variant="h5">
                Reset Password
        </Typography>) : (<Typography component="h1" variant="h5">
                  Sign in
        </Typography>)}
              <form className={classes.form} noValidate>
                <TextField
                  onChange={(e) => { this.setState({ email: e.target.value }) }}
                  variant="outlined"
                  margin="normal"
                  required
                  fullWidth
                  id="email"
                  label="Email Address"
                  name="email"
                  autoComplete="email"
                  autoFocus
                />
                {this.state.forgot ? (<div>

                  <Button
                    onClick={() => { this.forgotPassword() }}
                    fullWidth
                    variant="contained"
                    color="primary"
                    className={classes.submit}
                  >Reset Password</Button>
                </div>) : (<div><TextField
                  onChange={(e) => { this.setState({ password: e.target.value }) }}
                  variant="outlined"
                  margin="normal"
                  required
                  fullWidth
                  name="password"
                  label="Password"
                  type="password"
                  id="password"
                  autoComplete="current-password"
                />

                  <Button
                    onClick={() => { this.login() }}
                    fullWidth
                    variant="contained"
                    color="primary"
                    className={classes.submit}
                  >
                    Sign In
          </Button></div>)}

                <Grid item xs>
                  {this.state.forgot === false && <Link onClick={() => { this.setState({ forgot: true }) }} href="#" variant="body2">
                    Forgot password?
              </Link>}
                </Grid>
              </form>
            </div>
            {this.state.wrong && <div style={{ color: "#000080", fontFamily: "Roboto" }}><p>Email or Password is Wrong</p></div>}
            {this.state.notadmin && <div style={{ color: "#000080", fontFamily: "Roboto" }}><p>You Are Not An Admin</p></div>}
            {this.state.wrongs && <div style={{ color: "#000080", fontFamily: "Roboto" }}><p>Please Enter Correct Email</p></div>}
            {this.state.again && <div style={{ color: "#000080", fontFamily: "Roboto" }}><p>Please Login Again</p></div>}
          </Container>)}
      </div>
    );
  }
}

export default withStyles(styles)(App);